import { render, staticRenderFns } from "./siderFilterPitch.vue?vue&type=template&id=80671542&"
import script from "./siderFilterPitch.vue?vue&type=script&lang=js&"
export * from "./siderFilterPitch.vue?vue&type=script&lang=js&"
import style0 from "./siderFilterPitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports